import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	DpBenefitCouponCategorySX,
	DpBenefitCouponCodeFrameSX,
	DpBenefitCouponCodeSX,
	DpBenefitCouponContentSX,
	DpBenefitCouponCopyButtonSX,
	DpBenefitCouponDateSX,
	DpBenefitCouponDescriptionSX,
	DpBenefitCouponFrameSX,
	DpBenefitCouponImgSX,
} from '@/components/blocks/DpBenefitCoupon/style';

interface DpBenefitCouponProps {
	img: string;
	category: string;
	description: string;
	code: string;
	date: string;
}

export const DpBenefitCoupon: React.FC<DpBenefitCouponProps> = ({
	img,
	category,
	description,
	code,
	date,
}) => {
	const handleOnCopy = () => {
		navigator.clipboard.writeText(code);
	};

	return (
		<Box sx={DpBenefitCouponFrameSX}>
			<Img src={img} alt="Cupón" sx={DpBenefitCouponImgSX} />
			<Box sx={DpBenefitCouponContentSX}>
				<Typography component="h3" sx={DpBenefitCouponCategorySX}>
					{category}
				</Typography>
				<Typography sx={DpBenefitCouponDescriptionSX}>{description}</Typography>
				<Stack direction="row">
					<Box sx={DpBenefitCouponCodeFrameSX}>
						<Typography sx={DpBenefitCouponCodeSX}>{code}</Typography>
					</Box>
					<ButtonBase sx={DpBenefitCouponCopyButtonSX} onClick={handleOnCopy}>
						{'Copiar'}
					</ButtonBase>
				</Stack>
				<Typography sx={DpBenefitCouponDateSX}>{`Válido hasta el ${date}`}</Typography>
			</Box>
		</Box>
	);
};
